import * as React from "react";
import { ChoiceGroup, IChoiceGroupOption, IChoiceGroupStyles, IStackStyles, IStackTokens, PrimaryButton, Stack } from "@fluentui/react";
import { OneDriveOverWriteEnum } from "../../enums/oneDriveOverWriteEnum";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";

const stackStylesDefault: IStackStyles = {
  root: {
    paddingTop: 15
  }
};
const stackStylesPadded: IStackStyles = {
  root: {
    paddingTop: 15,
    paddingBottom: 15
  }
};
const stackTokens: IStackTokens = {
  childrenGap: 20
};
const choiceGroupStyles: IChoiceGroupStyles = { label: { fontSize: 16 } };

interface DuplicateFoldersProps {
  showSelectVersion?: boolean;
  onCancel?: () => void;
}

const DuplicateFolders: React.FunctionComponent<DuplicateFoldersProps> = (props: DuplicateFoldersProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const [folderOptions] = React.useState<IChoiceGroupOption[]>([
    { key: OneDriveOverWriteEnum.rename.toString(), text: languageStrings.Rename }
  ]);

  const cancelDuplicateSave = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    <Stack styles={!props.showSelectVersion ? stackStylesDefault : stackStylesPadded} tokens={stackTokens}>
      <ChoiceGroup
        defaultSelectedKey={OneDriveOverWriteEnum.rename.toString()}
        options={folderOptions}
        label={languageStrings.FolderSameNameAutoRename}
        styles={choiceGroupStyles}
        required={true}
      />
      {!props.showSelectVersion && <Stack.Item>
        <PrimaryButton text={languageStrings.Cancel} allowDisabledFocus onClick={cancelDuplicateSave} />
      </Stack.Item>}
    </Stack>
  )
};

export default DuplicateFolders;
